(function ($) {
  var elementorHookRegistered = false;

  function isInViewport($element) {
    if (!$element.length) {
      return false;
    }

    var elementTop = $element.offset().top;
    var elementBottom = elementTop + $element.outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  function animateNumber($number) {
    var countTo = String($number.attr('data-count') || '').replace(/\s/g, '');
    var target = parseFloat(countTo);

    if (!Number.isFinite(target)) {
      $number.text(countTo);
      $number.addClass('counted');
      return;
    }

    $({ countNum: parseFloat($number.text()) || 0 }).animate(
      { countNum: target },
      {
        duration: 2000,
        easing: 'linear',
        step: function () {
          $number.text(Math.floor(this.countNum).toLocaleString('fr'));
        },
        complete: function () {
          $number.text(Math.floor(this.countNum).toLocaleString('fr'));
        }
      }
    );

    $number.addClass('counted');
  }

  function runCounters($scope) {
    $scope.find('[data-icon-counter-number]').each(function () {
      var $number = $(this);

      if (!$number.hasClass('counted') && isInViewport($number)) {
        animateNumber($number);
      }
    });
  }

  function initIconCounter($scope) {
    var $counter = $scope.is('[data-icon-counter]')
      ? $scope
      : $scope.find('[data-icon-counter]').first();

    if (!$counter.length) {
      return;
    }

    runCounters($counter);

    if ($counter.data('icon-counter-bound')) {
      return;
    }

    $counter.data('icon-counter-bound', true);
    $(window).on('scroll.iconCounter resize.iconCounter load.iconCounter', function () {
      runCounters($counter);
    });
  }

  function registerElementorHook() {
    if (
      elementorHookRegistered ||
      !window.elementorFrontend ||
      !window.elementorFrontend.hooks
    ) {
      return;
    }

    elementorHookRegistered = true;
    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/icon-counter.default',
      initIconCounter
    );
  }

  $(window).on('elementor/frontend/init', registerElementorHook);

  $(function () {
    registerElementorHook();

    $('.elementor-widget-icon-counter').each(function () {
      initIconCounter($(this));
    });
  });
})(jQuery);
